// extracted by mini-css-extract-plugin
export default {"container":"XPTr51","text":"_dGQQq","buttonContainer":"LPgoWr"};